import React from 'react';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { ViewTitle } from 'react-admin';

const Dashboard = () => (
    <Card>
        <ViewTitle title="MSS Admin" />
        <CardContent>
            <span style={{ color: "lightgray" }}>Welcome to the MSS administration system...</span>
        </CardContent>
    </Card>
);

export default Dashboard;


// WEBPACK FOOTER //
// ./src/resources/dashboard.js